import { call, put } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { loadFileFailed, loadFileSuccessful } from '../actions';
import processError from '../../../utils/processError';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';

export default function* loadFile(action) {
  try {
    const link = action.payload;
    const pool = {};
    const dataResponse = yield makeRequest(link, pool, action, 'GET');
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(loadFileSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadFileFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadFileFailed([]));
    yield call(rejectActionPromise(action, {}));
    yield processError(e);
  }
}
